import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _titleMapping, _descriptionMapping, _footerMapping, _primaryCtaMapping;

var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Pocket, useIsFocused, useOnUserSelected } from '@pelotoncycle/waffles';
import React from 'react';
import { MediumButton } from '@webtv/buttons';
import { Copy } from '@webtv/copy-provider';
import { focusClass } from '@webtv/global-styles';
import { useGetLocale, DateTime } from '@webtv/internationalize';
import { ContractUpdateType, RequiredActions } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var titleMapping = (_titleMapping = {}, _defineProperty(_titleMapping, ContractUpdateType.policy, 'terms.updatedPolicies'), _defineProperty(_titleMapping, ContractUpdateType.terms, 'terms.updatedTerms'), _defineProperty(_titleMapping, ContractUpdateType.termsAndPolicies, 'terms.updatedTermsAndPolicies'), _titleMapping);
var descriptionMapping = (_descriptionMapping = {}, _defineProperty(_descriptionMapping, ContractUpdateType.policy, 'terms.policiesUpdateDescription'), _defineProperty(_descriptionMapping, ContractUpdateType.terms, 'terms.termsUpdateDescription'), _defineProperty(_descriptionMapping, ContractUpdateType.termsAndPolicies, 'terms.termsAndPoliciesUpdateDescription'), _descriptionMapping);
var footerMapping = (_footerMapping = {}, _defineProperty(_footerMapping, ContractUpdateType.policy, 'terms.policiesFooter'), _defineProperty(_footerMapping, ContractUpdateType.terms, 'terms.termsFooter'), _defineProperty(_footerMapping, ContractUpdateType.termsAndPolicies, 'terms.termsAndPoliciesFooter'), _footerMapping);
var primaryCtaMapping = (_primaryCtaMapping = {}, _defineProperty(_primaryCtaMapping, RequiredActions.accept, 'terms.accept'), _defineProperty(_primaryCtaMapping, RequiredActions.acknowledge, 'terms.acknowledge'), _defineProperty(_primaryCtaMapping, RequiredActions.acknowledgeAndAccept, 'terms.confirm'), _primaryCtaMapping);
export var TermsTakeoverView = function TermsTakeoverView(_ref) {
  var docsToShow = _ref.docsToShow,
      onContinueSelected = _ref.onContinueSelected,
      logout = _ref.logout,
      updatedContractTypes = _ref.updatedContractTypes,
      requiredAction = _ref.requiredAction;
  return /*#__PURE__*/_jsx(Pocket, {
    id: "main",
    vertical: true,
    position: 0,
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Info, {
        children: [/*#__PURE__*/_jsx(Title, {
          children: /*#__PURE__*/_jsx(Copy, {
            id: titleMapping[updatedContractTypes]
          })
        }), /*#__PURE__*/_jsx(SubTitle, {
          children: /*#__PURE__*/_jsx(Copy, {
            id: descriptionMapping[updatedContractTypes]
          })
        }), /*#__PURE__*/_jsx(Details, {
          children: /*#__PURE__*/_jsx(Copy, {
            id: footerMapping[updatedContractTypes]
          })
        })]
      }), /*#__PURE__*/_jsxs(Actions, {
        children: [docsToShow.map(function (doc, i) {
          return /*#__PURE__*/_jsx(Pocket, {
            id: doc.displayName,
            position: i,
            autofocus: i === 0,
            children: /*#__PURE__*/_jsx(DocLink, _objectSpread({}, doc))
          }, doc.displayName);
        }), /*#__PURE__*/_jsx(Pocket, {
          id: "continue",
          position: docsToShow.length,
          autofocus: true,
          children: /*#__PURE__*/_jsx(Continue, {
            onContinueSelected: onContinueSelected,
            children: /*#__PURE__*/_jsx(Copy, {
              id: primaryCtaMapping[requiredAction]
            })
          })
        }), /*#__PURE__*/_jsx(Pocket, {
          id: "logout",
          position: docsToShow.length + 1,
          children: requiredAction === RequiredActions.acknowledge ? /*#__PURE__*/_jsx(DismissButton, {
            handleClick: onContinueSelected
          }) : /*#__PURE__*/_jsx(Logout, {
            logout: logout
          })
        }), /*#__PURE__*/_jsx(Pocket, {
          id: "logout",
          position: docsToShow.length + 1
        })]
      })]
    })
  });
};

var DismissButton = function DismissButton(_ref2) {
  var handleClick = _ref2.handleClick;
  var isFocused = useIsFocused();
  useOnUserSelected(handleClick);
  return /*#__PURE__*/_jsx(LogoutLink, {
    className: cx(isFocused && focusClass),
    children: /*#__PURE__*/_jsx(Copy, {
      id: "terms.dismiss"
    })
  });
};

var DocLink = function DocLink(_ref3) {
  var displayName = _ref3.displayName,
      onDocSelected = _ref3.onDocSelected,
      createdAt = _ref3.createdAt;
  var getLocale = useGetLocale();
  var isFocused = useIsFocused();
  useOnUserSelected(onDocSelected);
  return /*#__PURE__*/_jsxs(TermsLinkContainer, {
    className: cx(isFocused && focusClass),
    children: [/*#__PURE__*/_jsx(DocTitle, {
      children: displayName
    }), /*#__PURE__*/_jsx(DocDate, {
      children: DateTime.toLocalizedSlashedDate(createdAt, getLocale)
    })]
  });
};

var Continue = function Continue(_ref4) {
  var onContinueSelected = _ref4.onContinueSelected,
      children = _ref4.children;
  var isFocused = useIsFocused();
  useOnUserSelected(onContinueSelected);
  return /*#__PURE__*/_jsx(ContinueButton, {
    className: cx(isFocused && focusClass),
    children: children
  });
};

var Logout = function Logout(_ref5) {
  var logout = _ref5.logout;
  var isFocused = useIsFocused();
  useOnUserSelected(logout);
  return /*#__PURE__*/_jsx(LogoutLink, {
    className: cx(isFocused && focusClass),
    children: /*#__PURE__*/_jsx(Copy, {
      id: "terms.logout"
    })
  });
};

var Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c5979lb"
});
var Info = /*#__PURE__*/styled("div")({
  name: "Info",
  class: "i1vy0hbf"
});
var Actions = /*#__PURE__*/styled("div")({
  name: "Actions",
  class: "a1llwd3p"
});
var TermsLinkContainer = /*#__PURE__*/styled("div")({
  name: "TermsLinkContainer",
  class: "t1e64haj"
});
var Title = /*#__PURE__*/styled("div")({
  name: "Title",
  class: "t19tryjv"
});
var SubTitle = /*#__PURE__*/styled("div")({
  name: "SubTitle",
  class: "s1mp2du8"
});
var Details = /*#__PURE__*/styled("div")({
  name: "Details",
  class: "djxu97d"
});
var DocTitle = /*#__PURE__*/styled("div")({
  name: "DocTitle",
  class: "dfxu47i"
});
var DocDate = /*#__PURE__*/styled("div")({
  name: "DocDate",
  class: "deoxzku"
});
var ContinueButton = /*#__PURE__*/styled(MediumButton)({
  name: "ContinueButton",
  class: "c1w1kbiz"
});
var LogoutLink = /*#__PURE__*/styled("div")({
  name: "LogoutLink",
  class: "l16ohv6h"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/contract-agreements/TermsTakeoverView.linaria.module.css");